module.exports = __webpack_public_path__ + "static/media/communication_records_active_es.be0fe120.svg";